interface Name {
  title: string;
  firstName: string;
  lastName: string;
}

export const formatName = ({ title, firstName, lastName }: Name) =>
  `${title} ${firstName} ${lastName}`;
